import { orpcClient } from '@/lib/api/orpc/client';
import type { AiChatModel } from './types';

/**
 * 回答エージェント（モデル）一覧を取得する。
 * BE の `GET /v2/ai-operator/chat/agents`（ai-operator の `GET /chat/agents` を中継）を型付き orpc で叩く。
 * マスタは ai-operator が SSoT。regulation 等が追加されても FE はそのまま表示・送信できる。
 */
export async function listAiChatModels(): Promise<AiChatModel[]> {
  const {
    agents
  } = await orpcClient.aiOperatorChat.listAgents();
  return agents;
}